import DeclarationOfConformity from './DeclarationOfConformity'

export default DeclarationOfConformity
